import { ArrowUpwardOutlined } from '@mui/icons-material';
import { ListItemIcon } from '@mui/material';
import { ExtendedListItemButton, ExtendedListItemText } from '@procureai/ui-mui';

import { MessageVariant } from '../Chat/ChatUserMessage/ChatUserMessage.types';

import { UseQuickActionResult, useQuickActionTranslation } from './ConversationQuickAction.hooks';
import { ConversationQuickActionType } from './ConversationQuickAction.types';

interface QuickActionProps {
  action: ConversationQuickActionType;
  onSubmit: UseQuickActionResult;
}

export const ConversationQuickAction = ({ action, onSubmit }: QuickActionProps) => {
  const { getTranslatedText } = useQuickActionTranslation();

  const title = getTranslatedText(action.titleTranslations);
  const helpText = getTranslatedText(action.helpTextTranslations);

  return (
    <ExtendedListItemButton
      component="li"
      // Using inline style as this better works with breakpoint styling
      // and does not break `component` prop forwarding
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        maxWidth: {
          xs: 300,
          xl: 400,
        },
        backgroundColor: theme.palette.background.paper,
      })}
      data-intercom-target={`QuickActionMenu/${action.id}`}
      onClick={() =>
        onSubmit({ text: action.prompt }, { type: MessageVariant.QUICK_ACTION, title: title, helpText: helpText })
      }
    >
      <ExtendedListItemText primary={title} secondary={helpText} secondaryLines={2} />
      <ListItemIcon>
        <ArrowUpwardOutlined />
      </ListItemIcon>
    </ExtendedListItemButton>
  );
};
